export default __webpack_public_path__ + "static/media/p25.d32ac194.jpg";